<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2a"><a id="ch00_fm01"></a><a id="page_i"><strong><em>Blood Relative</em></strong></a></h2><a id="page_i">
<p class="noindent2">I tossed the cotton pad at the garbage can, but missed. I bent to pick it up. That’s when I noticed a smear of red on the white plastic garbage liner. It looked like . . . blood!</p>
<p class="indent">Frowning, I shook the edge of the can to shift the contents. A crumpled tissue rolled to one side and I spotted a small plastic bottle labeled <span class="smallcaps">TRANSPARENT NONDRYING STAGE BLOOD.</span> It was empty but for a few drops.</p>
<p class="indent">I crouched there on my heels, trying to understand what I was seeing. Stage blood? Why was there an empty bottle of stage blood in our bathroom?</p>
<p class="indent">Suddenly I flashed back to Kelly’s flushed face and furtive manner as she slipped back into the reception room after the animal-rights protesters were hauled away. The animal-rights protesters who’d been made up with gallons of stage blood.</p>
<p class="indent">Had Kelly had something to do with that protest? It seemed as though nothing else could explain the stage blood in the garbage can.</p>
<p class="indent">Why on earth would Kelly want to sabotage her own father’s company?</p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch00_fm01.vue?33fabfd6